





























import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import Resumo from "./components/financeiro/Resumo.vue";

//Graficos
import GraficoFaturamentoDiario from "./components/financeiro/GraficoFaturamentoDiario.vue";
import GraficoFaturamentoAcumulado from "./components/financeiro/GraficoFaturamentoAcumulado.vue";
import GraficoPlanoDiario from './components/financeiro/GraficoPlanoDiario.vue';
import GraficoPrevisaoFaturamento from './components/financeiro/GraficoPrevisaoFaturamento.vue'
//Fim Gráficos

import {
  DashboardService,
  FaturamentoDiario,
} from "@/services/dashboard.service";

@Component({
  components: { Resumo, GraficoFaturamentoDiario, GraficoFaturamentoAcumulado, GraficoPlanoDiario, GraficoPrevisaoFaturamento },
})
export default class Financeiro extends Mixins(GlobalMixin) {
  loadingFaturamentos = false;
  faturamentosDiario: FaturamentoDiario[] | null = null;

  data: string | null = null;

  mounted() {
    this.onChangeValue(this.value);
  }

  @Prop() readonly value!: string;
  @Watch("value")
  onChangeValue(val: string) {
    this.data = val;
    this.carregarFaturamentos();
  }
  @Watch("data")
  onChangeData(val: string) {
    this.$emit("input", val);
  }

  //Uma requisição devolve a fonte para três gráficos
  //Faturamento por dia, acumulado e planos por dia
  async carregarFaturamentos() {
    this.loadingFaturamentos = true;
    if (this.data) {
      this.faturamentosDiario = await DashboardService.faturamentoDiario(
        this.data
      ).finally(() => (this.loadingFaturamentos = false));
    }
  }
}
